import { useEffect } from 'react';

import { getFragmentData } from '@e-socna/data-layer';
import type { FragmentType } from '@e-socna/data-layer';

import { quotationEmitterColorOf } from '../utils/quotation-emitter-color-of.util';
import { UiSettingsContext_QuotationEmitters_Fragment } from '../fragments/quotation-emitters.fragment';
import type { SpaceLevel } from '../enums/space-level.enum';

import { useUiSettingsContext } from './useUiSettingsContext.hook';

// The space gives its quotation emitter colour to the theme while it is shown.
export const useSpaceEmitterColor = (
  level: SpaceLevel,
  pConsolidation:
    | FragmentType<typeof UiSettingsContext_QuotationEmitters_Fragment>
    | undefined,
) => {
  const { setSpaceEmitterColor } = useUiSettingsContext();
  const consolidation = getFragmentData(
    UiSettingsContext_QuotationEmitters_Fragment,
    pConsolidation,
  );
  const color = consolidation
    ? quotationEmitterColorOf(consolidation)
    : undefined;

  useEffect(() => {
    setSpaceEmitterColor(level, color);

    return () => {
      setSpaceEmitterColor(level, undefined);
    };
  }, [color, level, setSpaceEmitterColor]);
};
